module.exports = __webpack_public_path__ + "img/sld_icog_panel_t1_b1.0cec81b8.svg";